module.exports = __webpack_public_path__ + "img/paypalbutton2.7057a31c.jpg";